import { Button, FormField, Stack, TextInput } from 'canoe';
import { Field, FieldInputProps, FieldMetaProps, Form, Formik } from 'formik';
import React from 'react';
import * as Yup from 'yup';

import { ContentType } from '@candu-ai/content/types';

const validationSchema = Yup.object().shape({
  prompt: Yup.string()
    .min(3, 'Must have at least 3 characters')
    .max(255, 'Cannot be longer then 255 characters'),
});

interface GenerateContentFormProps {
  onSubmit: (payload: object) => void;
}

export const GenerateContentForm = ({ onSubmit }: GenerateContentFormProps) => {
  return (
    <Formik
      validateOnMount
      initialValues={{
        prompt: undefined,
      }}
      validationSchema={validationSchema}
      onSubmit={({ ...props }) => onSubmit({ ...props })}
    >
      {({ isSubmitting, isValid }) => (
        <Form data-cy="create-content-form">
          <Field name="prompt">
            {({
              field,
              meta,
            }: {
              field: FieldInputProps<ContentType>;
              meta: FieldMetaProps<string>;
            }) => (
              <FormField
                label=""
                feedback={meta.touched ? meta.error : ''}
                state={meta.touched && meta.error ? 'danger' : 'none'}
              >
                <TextInput
                  {...field}
                  value={field.value || ''}
                  placeholder="Describe the type of content you'd like to create."
                />
              </FormField>
            )}
          </Field>

          <Stack justify="center">
            <Button
              type="submit"
              variant="secondary"
              mt="s"
              loading={isSubmitting}
              disabled={!isValid}
            >
              Generate Content
            </Button>
          </Stack>
        </Form>
      )}
    </Formik>
  );
};
